import type { ReportRequest } from "./contracts";

function sortValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(sortValue);
  }

  if (value !== null && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .sort(([left], [right]) => left.localeCompare(right))
        .map(([key, nestedValue]) => [key, sortValue(nestedValue)]),
    );
  }

  return value;
}

export function canonicalReportInput(request: ReportRequest): string {
  return JSON.stringify(sortValue(request));
}

export async function hashReportInput(request: ReportRequest): Promise<string> {
  const bytes = new TextEncoder().encode(canonicalReportInput(request));
  const digest = await crypto.subtle.digest("SHA-256", bytes);

  return Array.from(new Uint8Array(digest), (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("");
}
